import React from "react";
import SEO from "@/components/SEO";

export default function TermosPage() {
  const updated = "Fevereiro de 2026";
  return (
    <div data-testid="page-termos">
      <SEO
        title="Termos de utilização"
        description="Termos e condições de utilização do website casanoporto.com da Zélia Silva, consultora imobiliária associada à eXp Portugal."
        canonical="https://casanoporto.com/termos"
      />

      <section className="container-cnp pt-14 lg:pt-20 pb-6">
        <div className="max-w-3xl">
          <span className="tag-chip">Legal</span>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl text-stone-900 leading-[1.05] tracking-[-0.02em]">
            Termos de utilização
          </h1>
          <p className="mt-4 text-sm text-stone-500">Última actualização: {updated}</p>
        </div>
      </section>

      <section className="container-cnp pb-24">
        <div className="prose-cnp max-w-3xl">

          <h2>1. Quem somos</h2>
          <p>
            Este website — <strong>casanoporto.com</strong> — é operado pela consultora imobiliária <strong>Zélia Silva</strong>,
            no âmbito da sua actividade profissional junto da mediadora imobiliária <strong>eXp Global Portugal, Lda.</strong>,
            titular da licença AMI n.º 18470, com sede na Praça Marquês de Pombal, n.º 14, 1250-162 Lisboa.
          </p>
          <p>
            Contactos: <a href="mailto:zelia.silva@expportugal.com">zelia.silva@expportugal.com</a> · +351 967 155 498.
          </p>

          <h2>2. Objecto</h2>
          <p>
            O presente website destina-se a divulgar informação relativa a imóveis, zonas do Porto e Grande Porto,
            serviços de mediação imobiliária, artigos de blog e a permitir o contacto entre visitantes e a consultora.
            A utilização do website implica a aceitação integral destes Termos.
          </p>

          <h2>3. Utilização permitida</h2>
          <p>Ao aceder e utilizar o website, o utilizador compromete-se a:</p>
          <ul>
            <li>Utilizar o website apenas para fins lícitos e de acordo com estes Termos.</li>
            <li>Não introduzir dados falsos, enganosos ou de terceiros sem consentimento.</li>
            <li>Não tentar aceder a áreas restritas nem interferir com o funcionamento do website.</li>
            <li>Não reproduzir, distribuir ou reutilizar comercialmente conteúdos sem autorização escrita.</li>
          </ul>

          <h2>4. Informação sobre imóveis</h2>
          <p>
            A informação divulgada sobre cada imóvel — descrição, fotografias, área, tipologia, preço, localização,
            certificação energética — é fornecida a título indicativo, tendo por base os elementos comunicados pelo
            proprietário ou disponibilizados por fontes de referência à data da publicação.
          </p>
          <p>
            Podem existir alterações, indisponibilidades temporárias ou lapsos de actualização. Antes de qualquer
            decisão de compra ou reserva, o utilizador deve confirmar todos os dados directamente com a consultora,
            que fornecerá também a documentação técnica e legal do imóvel.
          </p>

          <h2>5. Comparador de preços e estimativas</h2>
          <p>
            O <strong>Comparador de preços</strong> e as referências de €/m² por zona e tipologia apresentadas no
            website são <strong>estimativas indicativas</strong> baseadas em índices de mercado públicos
            (nomeadamente Idealista, Confidencial Imobiliário e Ranking Imobiliário) e no comportamento típico do
            mercado português. Não substituem uma avaliação profissional ao imóvel, que depende sempre do estado,
            andar, exposição, ano de construção, certificação e outros factores específicos.
          </p>

          <h2>6. Formulários, contactos e leads</h2>
          <p>
            Ao submeter um formulário — contacto, pedido de avaliação, marcação de reunião ou subscrição da
            newsletter — o utilizador declara ter fornecido dados verdadeiros e autoriza a Zélia Silva a
            responder e a contactá-lo pelos meios indicados. O tratamento dos dados pessoais segue as regras
            descritas na <a href="/politica-de-privacidade">Política de Privacidade</a>.
          </p>

          <h2>7. Propriedade intelectual</h2>
          <p>
            Todos os textos, imagens, logótipos, marca &quot;casa no porto&quot;, ilustrações e código do website
            são propriedade da Zélia Silva ou dos seus legítimos titulares e estão protegidos pela legislação
            aplicável. É proibida a sua reprodução, cópia, distribuição ou uso comercial sem autorização escrita.
          </p>
          <p>
            Imagens de bancos de imagens são utilizadas ao abrigo das respectivas licenças. Fotografias específicas
            de cada imóvel são obtidas com autorização do proprietário.
          </p>

          <h2>8. Ligações externas</h2>
          <p>
            O website pode conter ligações para sites de terceiros (redes sociais, WhatsApp, mapas, portais
            imobiliários). Esses sites são independentes e regem-se pelos seus próprios termos e políticas — não
            somos responsáveis pelo respectivo conteúdo, práticas ou disponibilidade.
          </p>

          <h2>9. Limitação de responsabilidade</h2>
          <p>
            Envidamos todos os esforços para manter o website disponível, seguro e com informação actualizada.
            Não garantimos, contudo, o funcionamento ininterrupto e livre de erros. Na medida máxima permitida por
            lei, ficam excluídas responsabilidades por danos indirectos ou consequenciais resultantes da
            utilização ou impossibilidade de utilização do website.
          </p>

          <h2>10. Alterações aos Termos</h2>
          <p>
            Estes Termos podem ser actualizados sempre que existam alterações relevantes ao website, aos serviços
            ou à legislação aplicável. A data da última actualização consta no topo desta página. Recomendamos
            consulta periódica.
          </p>

          <h2>11. Lei aplicável e foro</h2>
          <p>
            Estes Termos regem-se pela lei portuguesa. Para dirimir eventuais litígios, é competente o foro da
            comarca do Porto, com renúncia expressa a qualquer outro.
          </p>

          <h2>12. Resolução alternativa de litígios</h2>
          <p>
            Em caso de litígio de consumo, o consumidor pode recorrer à entidade de resolução alternativa de
            litígios de consumo competente:{" "}
            <a href="https://www.cniacc.pt" target="_blank" rel="noopener noreferrer">
              CNIACC — Centro Nacional de Informação e Arbitragem de Conflitos de Consumo
            </a>
            . Mais informação em{" "}
            <a href="https://www.consumidor.gov.pt" target="_blank" rel="noopener noreferrer">consumidor.gov.pt</a>.
          </p>

          <h2>13. Contacto</h2>
          <p>
            Dúvidas sobre estes Termos:{" "}
            <a href="mailto:zelia.silva@expportugal.com">zelia.silva@expportugal.com</a>.
          </p>

          <p className="text-xs text-stone-500 mt-10">
            Este texto tem carácter informativo. Para questões jurídicas específicas, recomenda-se aconselhamento
            de advogado.
          </p>
        </div>
      </section>
    </div>
  );
}
